import {
  KoButton,
  Checkbox,
  KoDate,
  KoInput,
  KoNumber,
  Radio,
  Rate,
  Select,
  KoTextArea,
  KoPassword
} from '../index';

import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import React from 'react';
import FormBuilder from './formbuilder';

// ------------------ Utility ------------------
const mapOptions = (options) => {
  if (!isArray(options)) {
    console.warn('Invalid options passed to mapOptions:', options);
    return [];
  }

  return options.map((opt) => {
    if (isArray(opt)) {
      return { value: opt[0], label: opt[1] };
    } else if (isPlainObject(opt)) {
      return opt;
    } else {
      return { value: opt, label: opt };
    }
  });
};

// ------------------ Widgets ------------------

FormBuilder.defineWidget('button', KoButton);

FormBuilder.defineWidget('input', KoInput, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('password', KoPassword, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('textarea', KoTextArea, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('number', KoNumber, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('datePicker', KoDate, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('rating', Rate, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('checkbox', Checkbox, (field) => ({
  ...field,
  valuePropName: 'checked',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('radio', Radio, (field) => ({
  ...field,
  valuePropName: 'value',
  widgetProps: {
    ...field.widgetProps
  }
}));

FormBuilder.defineWidget('radioGroup', Radio.Group, (field) => {
  const RadioComp = field.buttonGroup ? Radio.Button : Radio;

  if (field.options && !field.children) {
    return {
      ...field,
      valuePropName: 'value',
      widgetProps: {
        ...field.widgetProps,
        name: field.key
      },
      children: mapOptions(field.options).map((opt) => (
        <RadioComp value={opt.value} key={opt.value}>
          {opt.label}
        </RadioComp>
      ))
    };
  }

  return {
    ...field,
    valuePropName: 'value',
    widgetProps: {
      ...field.widgetProps
    }
  };
});

FormBuilder.defineWidget('checkboxGroup', Checkbox.Group, (field) => {
  if (field.options && !field.children) {
    return {
      ...field,
      valuePropName: 'value',
      widgetProps: {
        ...field.widgetProps,
        options: mapOptions(field.options)
      }
    };
  }

  return {
    ...field,
    valuePropName: 'value',
    widgetProps: {
      ...field.widgetProps
    }
  };
});

FormBuilder.defineWidget('select', Select, (field) => {
  if (field.options && !field.children) {
    return {
      ...field,
      valuePropName: 'value',
      widgetProps: {
        ...field.widgetProps
      },
      children: mapOptions(field.options).map((opt) => (
        <Select.Option
          key={opt.value}
          value={opt.value}
          disabled={opt.disabled}
        >
          {opt.children || opt.label}
        </Select.Option>
      ))
    };
  }

  return {
    ...field,
    valuePropName: 'value',
    widgetProps: {
      ...field.widgetProps
    }
  };
});
